import { Button } from "@/components/ui/button";
import { ColumnDef } from "@tanstack/react-table";
import { Link } from "react-router-dom";
import {
  MessageStatusMapping,
} from "../models/order.model";
import { Eye } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export const contactMessagesTableColumns: ColumnDef<any>[] = [
  {
    accessorKey: "createdAt",
    header: () => <Button variant="ghost">Date Created</Button>,
    cell: ({ row }) => (
      <div className="uppercase">
        {new Date(row.getValue("createdAt") as string).toLocaleString("en-GM", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        })}
      </div>
    ),
  },
   {
    accessorKey: "updatedAt",
    header: () => <Button variant="ghost">Updated At</Button>,
    cell: ({ row }) => (
      <div className="uppercase">
        {new Date(row.getValue("updatedAt") as string).toLocaleString("en-GM", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        })}
      </div>
    ),
  },
  {
    accessorKey: "user",
    header: () => <Button variant="ghost">Name</Button>,
    cell: ({ row }) => (
      <div>{(row.getValue<any>("user").name || "-") as React.ReactNode}</div>
    ),
  },
  {
    accessorKey: "user",
    header: () => <Button variant="ghost">Email</Button>,
    cell: ({ row }) => (
      <div>{(row.getValue<any>("user").email || "-") as React.ReactNode}</div>
    ),
  },
  {
    accessorKey: "plateNumber",
    header: () => <Button variant="ghost">Phone</Button>,
    cell: ({ row }) => (
      <div>{(row.getValue<any>("user").phone || "-") as React.ReactNode}</div>
    ),
  },

  {
    accessorKey: "inquiry",
    header: () => <Button variant="ghost">Subject</Button>,
    cell: ({ row }) => (
      <div>
        {(row.getValue<any>("inquiry").subject || "-") as React.ReactNode}
      </div>
    ),
  },
  {
    accessorKey: "inquiry",
    header: () => <Button variant="ghost">Message</Button>,
    cell: ({ row }) => (
      <div>
        {(row.getValue<any>("inquiry").message || "-") as React.ReactNode}
      </div>
    ),
  },

  {
    accessorKey: "status",
    header: () => <Button variant="ghost">Status</Button>,
    cell: ({ row }) => {
      const status = row.getValue("status");
      return (
        <div
          className={`capitalize ${
            status === "new"
              ? "text-error"
              : status === "in_progress"
              ? "text-warning"
              : status === "resolved"
              ? "text-success"
              : ""
          }`}
        >
          {MessageStatusMapping[status as string] as React.ReactNode}
        </div>
      );
    },
  },
  // {
  //   id: "actions",
  //   enableHiding: false,
  //   header: ({ column }) => (
  //     <Button
  //       variant="ghost"
  //       onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
  //     >
  //       Actions
  //     </Button>
  //   ),
  //   cell: ({ row }) => {
  //     return (
  //       <TooltipProvider>
  //         <Tooltip>
  //           <TooltipTrigger asChild>
  //             <Link to={`/app/contactMessages/${row.original.id}`}>
  //               <Button variant="outline" className="h-8 w-8 p-0">
  //                 <Eye className="h-4 w-4" />
  //               </Button>
  //             </Link>
  //           </TooltipTrigger>
  //           <TooltipContent>
  //             <p>View order details</p>
  //           </TooltipContent>
  //         </Tooltip>
  //       </TooltipProvider>
  //     );
  //   },
  // },
];
